import clsx from 'clsx';

import Card, { CardActionArea } from 'components/Card';
import Save from 'components/Listing/components/Buttons/components/Save';
import { FixedImage } from 'components/NextImage';
import Rating from 'components/Rating';
import { useEventContext } from 'context/EventContext';
import openUrl from 'helpers/openUrl';
import { getengagementDestination } from 'helpers/reviews';
import useViewport from 'hooks/useViewport';

import classes from './ListingItem.module.scss';

// The card should be clickable on mobile, but only title and logo on desktop. So have to add
// some unusual behavior to CardActionArea
const ListingItem = ({ listing }) => {
  const {
    logo_url,
    tagline,
    cta_urls,
    num_reviews,
    rating_avg,
    name,
    global_product_id,
    reviews,
  } = listing;
  const { is } = useViewport();

  const { addEvent } = useEventContext({
    engagementComponent: 'product_card-item',
  });

  const ctaEventProps = addEvent({
    engagementDestination: 'go-to_product_details',
    engagementDetails: 'text-link_product-name',
    name: 'engagement_product_click',
    productClickUUID: global_product_id,
  });

  return (
    <Card
      className={clsx('ListingItem', classes.root)}
      elevation={0}
      data-testid="explore-listing-item"
    >
      <CardActionArea
        className={clsx(classes.contentWrap, classes.focusHighlight)}
        disableRipple={!is('xs')}
        onClick={() => openUrl(cta_urls.detail, { target: '_self' })}
        component="div"
        {...ctaEventProps}
      >
        <div className={classes.leftCont}>
          <a
            href={cta_urls.detail}
            {...ctaEventProps}
            data-testid="category-item-title"
            className={classes.imageContainer}
          >
            <FixedImage
              width={40}
              className={classes.imageIcon}
              src={logo_url}
              alt={name}
            />
          </a>
        </div>
        <div className={classes.rightCont}>
          <div className={classes.topTitle}>
            <div>
              <a
                href={cta_urls.detail}
                className={classes.title}
                {...ctaEventProps}
                data-testid="title-item-name"
              >
                {name}
              </a>
              <Rating.Link
                className={classes.rating}
                href={cta_urls.reviews}
                average={rating_avg}
                totals={num_reviews}
                isCompact={true}
                data-testid="category-item-reviews"
                ratings={reviews?.by_rating}
                onClick={(e) => e.stopPropagation()}
                {...addEvent({
                  engagementDestination: getengagementDestination(
                    cta_urls.reviews
                  ),
                  engagementDetails: 'data_overall-rating_stars',
                  name: 'engagement_product_click',
                })}
              />
            </div>
          </div>
          <p className={classes.description}>{tagline}</p>
        </div>
      </CardActionArea>
      <Save
        listing={listing}
        className={classes.saveButton}
        engagementComponent="product_card-item"
        onlyIcon={true}
      />
    </Card>
  );
};

export default ListingItem;
